import { useEffect } from "react";
import { MissingPage } from "pages/errors";
import { ControlPanelPage } from "@templates/pageLayouts";
import { useUnitLists } from "@unitLists/hooks";
import MeasureDetailView from "./view/MeasureDetailView";
import MeasureDetailControlPanel from "./controlpanel/MeasureDetailControlPanel";
import useMeasureDetail from "./measureDetail.hook";
import { QueryContextProvider, PARAMSTYPES } from "contexts/searchParams";
import useDefaultParams from "./defaultParams";
import { jsx as _jsx } from "react/jsx-runtime";
var MeasureDetail = function MeasureDetail() {
  var _useMeasureDetail = useMeasureDetail(),
    appState = _useMeasureDetail.appState,
    setPartialAppState = _useMeasureDetail.setPartialAppState,
    metadata = _useMeasureDetail.metadata,
    measurementsWithMetadata = _useMeasureDetail.measurementsWithMetadata,
    reportingUnits = _useMeasureDetail.reportingUnits,
    organizations = _useMeasureDetail.organizations,
    loading = _useMeasureDetail.loading,
    error = _useMeasureDetail.error;
  useUnitLists(appState, setPartialAppState);
  useEffect(function () {
    if (metadata && error !== 404 && error !== 400) {
      document.title = metadata.library[metadata.parentMeasure].label;
      document.getElementsByTagName("meta").description.content = metadata.measureDefinition;
    }
  }, [metadata, error]);
  return error === 404 || error === 400 ? /*#__PURE__*/_jsx(MissingPage, {}) : metadata ? /*#__PURE__*/_jsx(ControlPanelPage, {
    id: "measuredetail",
    controlpanel: /*#__PURE__*/_jsx(MeasureDetailControlPanel, {
      metadata: metadata,
      query: appState,
      setQuery: setPartialAppState,
      measurementsWithMetadata: measurementsWithMetadata,
      reportingUnits: reportingUnits
    }),
    title: "Inst\xE4llningar",
    view: /*#__PURE__*/_jsx(MeasureDetailView, {
      metadata: metadata,
      measurementsWithMetadata: measurementsWithMetadata,
      query: appState,
      setQuery: setPartialAppState,
      loading: loading,
      organizations: organizations
    })
  }) : null;
};
export default function MeasureDetailWrapper() {
  var defaultParams = useDefaultParams();
  return /*#__PURE__*/_jsx(QueryContextProvider, {
    paramTypes: {
      units: PARAMSTYPES.ArrayParam,
      measureIds: PARAMSTYPES.ArrayParam,
      dateFrom: PARAMSTYPES.DateParam,
      dateTo: PARAMSTYPES.DateParam,
      showPrevious: PARAMSTYPES.BooleanParam,
      showTarget: PARAMSTYPES.BooleanParam,
      showCi: PARAMSTYPES.BooleanParam,
      showReich: PARAMSTYPES.BooleanParam,
      zoom: PARAMSTYPES.BooleanParam
    },
    omittedState: ["parentMeasure", "showImgView", "colorSettings"],
    defaultParams: defaultParams,
    alwaysInclude: ["units", "dateFrom", "dateTo"],
    updateAppStateOnSearchChanges: true,
    children: /*#__PURE__*/_jsx(MeasureDetail, {})
  });
}